import { render, staticRenderFns } from "./FreeConfirmation.vue?vue&type=template&id=65c44bd1"
import script from "./FreeConfirmation.vue?vue&type=script&lang=js"
export * from "./FreeConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports